<template>
  <div id="app">
    <section class="content" v-if="$route.name==='Announcement'">
      <transition name="page" mode="out-in">
        <Announcement></Announcement>
      </transition>
    </section>
    <div class="wrapper" v-else-if="$root.hasUser">
      <NaviMobile v-if="$root.device.isMobile"></NaviMobile>
      <NaviBar v-else></NaviBar>
      <Slider></Slider>
      <ContentWrapMobile v-if="$root.device.isMobile" class="sidebar-toggle"></ContentWrapMobile>
      <ContentWrap v-else></ContentWrap>
      <Modal></Modal>
    </div>
    <section class="content" v-else-if="$route.name!=='Home'">
      <transition name="page" mode="out-in">
        <Login></Login>
      </transition>
    </section>
    <transition v-else name="page" mode="out-in">
      <Home></Home>
    </transition>
    <notifications position="bottom right" :closeOnClick="true" />
  </div>
</template>

<script>
  import Announcement from './pages/Announcement.vue'
  import Login from './pages/Login.vue'
  import Home from './pages/Home.vue'
  import NaviBar from 'NaviBar.vue'
  import NaviMobile from 'NaviMobile.vue'
  import Slider from 'Slider.vue'
  import ContentWrap from 'ContentWrap.vue'
  import ContentWrapMobile from 'ContentWrapMobile.vue'
  import Modal from './components/Modal.vue'
  import store from './vuex/store.js'

  export default {
    name: 'app',
    components: {
      Home,
      Announcement,
      Login,
      Modal,
      NaviBar,
      NaviMobile,
      Slider,
      ContentWrap,
      ContentWrapMobile
    },
    store,
    created () {
    },
    mounted () {
    },
    updated () {
      console.log('app updated')
    },
    computed: {
      activeMenu () {
        return this.$route.name
      }
    },
    watch: {
      activeMenu (val) {
        console.log('app activeMenu = ' + val)
      }
    },
    methods: {
    }
  }
</script>

<style>
  #app {
    height: 100vh !important;
    min-height: 100vh !important;
    background-color: #ecf0f5;
    background-color: #FFFFFF;
  }
  .wrapper {
    background-color: #ecf0f5 !important;
  }
  .notifyBox {

  }
</style>



// WEBPACK FOOTER //
// App.vue?4751cd94